import React, { useState } from "react";
import bgImage from "../components/images/contactbg.png";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData as any).toString(),
    })
      .then(() => {
        setSubmitted(true);
        form.reset(); // 🔹 clears the form
      })
      .catch((error) => alert(error));
  };

  return (
    <section
      className="relative w-full min-h-screen flex items-center justify-end text-center text-white overflow-hidden"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-lg w-full px-12 py-6 bg-black/80 mr-12 md:mr-24 lg:mr-40">
        <h2 className="text-4xl font-heading mb-2 text-center">
          Get in Touch
        </h2>

        {/* ✅ SUCCESS MESSAGE */}
        {submitted && (
          <p className="text-green-400 text-sm mb-4 text-center">
            Thank you for your message, we will connect with you shortly.
          </p>
        )}

        {/* ✅ NETLIFY FORM */}
        <form
          name="contact"
          method="POST"
          data-netlify="true"
          netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
          className="space-y-4"
        >
          {/* Required hidden input for Netlify */}
          <input type="hidden" name="form-name" value="contact" />

          {/* Honeypot (spam protection) */}
          <input type="hidden" name="bot-field" />

          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            className="w-full p-3 rounded text-samBlue"
          />

          <input
            type="text"
            name="phone"
            placeholder="Your Contact Number"
            required
            className="w-full p-3 rounded text-samBlue"
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            className="w-full p-3 rounded text-samBlue"
          />

          <textarea
            name="message"
            placeholder="Your Message"
            required
            className="w-full p-3 rounded text-samBlue h-32"
          ></textarea>

          <button
            type="submit"
            className="bg-samAmber hover:bg-samCream text-samBlue px-6 py-3 rounded font-semibold w-full transition"
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
}
